import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Alert from '@material-ui/lab/Alert';
import CardForm from './CardForm';

const AddPaymentMethodDialogue = ({onCancel, onConfirm, providerUuid, errorMessage, busy}) => {

  return (
    <Dialog open={true} onClose={onCancel} aria-labelledby="form2-dialog-title">
      <DialogTitle id="form2-dialog-title">Add Payment Method</DialogTitle>
      <DialogContent>
        <CardForm
          allowDelete={false}
          onComplete={onConfirm}
          onCancel={onCancel}
          buttonLabel="Add Payment Method"
          providerUuid={providerUuid}
          busy={busy}
        />
        {errorMessage &&
          <Alert severity="error">
            {errorMessage}
          </Alert>
        }
      </DialogContent>
    </Dialog>
  );
};

AddPaymentMethodDialogue.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  providerUuid: PropTypes.string,
  errorMessage: PropTypes.string,
  busy: PropTypes.bool,
};

export default AddPaymentMethodDialogue;
